import { Configuration, LogLevel } from '@azure/msal-browser';

// ⬇️ REEMPLAZA estos valores con los que copiaste del Azure Portal
const CLIENT_ID = 'db0abde1-93b1-4e6d-9398-74ff56942a06';   // Tu Application (client) ID
const TENANT_ID = 'ac25d1a1-8671-47f5-9d3d-56f9bf1c964b';   // Tu Directory (tenant) ID

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: 'http://localhost:4200',   // Debe coincidir con Azure
    postLogoutRedirectUri: 'http://localhost:4200',
  },
  cache: {
    cacheLocation: 'localStorage',   // Guarda el token en localStorage
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        console.log(`[MSAL] ${message}`);
      },
      piiLoggingEnabled: false,
    },
  },
};

// Scopes = permisos que pedimos al usuario al loguearse
export const loginRequest = {
  scopes: ['User.Read', 'Calendars.ReadWrite'],
};

// Scopes específicos para llamar a Microsoft Graph API
export const graphScopes = {
  scopes: ['https://graph.microsoft.com/Calendars.ReadWrite'],
};
